import api from '../call'

export default {
  add_lookup_log: async (lookup, referrer) => {
    return await  api.apiCall('POST', 'api', 'lookup', {'lookup': lookup, 'referrer': referrer})
  },
  get_lookup_history: async (page, filters) => {
    return await  api.apiCall('GET', 'api/cnpj', 'lookup-history', `page=${page}&filters=${filters}`)
  },
  get_lookup_history_recent: async (filters) => {
    return await  api.apiCall('GET', 'api/cnpj', 'lookup-history-recent', `filters=${filters}`)
  },
  get_lookup_history_totals: async () => {
    return await  api.apiCall('GET', 'api/cnpj', 'lookup-history-totals')
  },
  tab_click_data: async (payload) => {
    return await api.apiCall('POST', 'api', `tab_click_data`, payload)
  }
}
